module.exports = "/powered-by-google-0779c56f37a41a67bf7b9ae48b5d1d7b.svg";